import { css } from '@emotion/core'

export const sectionOrder = css`
  .partnership-section:first-of-type {
    margin-top: 2rem;
  }
`
